import { render, staticRenderFns } from "./address-view.vue?vue&type=template&id=3d39580e"
import script from "./address-view.vue?vue&type=script&lang=js"
export * from "./address-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports